import { Box }                      from '@chakra-ui/react';
import CodeModel                    from '@/models/services/code/CodeModel';
import QRCode                       from 'react-qr-code';
import { SupportedLanguage }        from '@/hooks/useTranslations';
import { Text }                     from '@chakra-ui/react';
import { useTranslation }           from 'react-i18next';
import FondationsEntertainmentModel from '@/models/services/fondations/EntertainmentModel';

interface IQRCodeRowProps {
	code: CodeModel;
	gespassEntertainment: FondationsEntertainmentModel | undefined;
}

const QRCodeRow = (props: IQRCodeRowProps) => {

	const { code, gespassEntertainment }  = props;

	const { i18n } = useTranslation();
	const language = i18n.language as SupportedLanguage;

	return (
		<Box
			display="flex"
			gap="20px"
		>
			<Box minWidth="100px"><QRCode value={code.value} size={100} /></Box>
			<Box
				display="flex"
				flexDirection="column"
				gap="5px"
			>
				<Box>
					<Text className='poppins-semibold' fontSize="25px" >
						{code.getTitle(i18n.language as SupportedLanguage)}
					</Text>
				</Box>
				<Box
					display="flex"
					flexDirection="column"
					gap="5px"
				>
					<Box>
						<Text className='poppins-semibold' >
							{code.value}
						</Text>
					</Box>
					<Box
						display="flex"
						alignItems="center"
						gap="15px"
					>
						<Box><Text>{code.isGespass ? gespassEntertainment?.getTitle(language) : code.codeType.source.product.entertainment.title}</Text></Box>
					</Box>
				</Box>
			</Box>
		</Box>
	)
}

export default QRCodeRow